
const BarStackedDataAPI = (response) => {

    const chartBar = []
    const uniqueArrayN = []
    const uniqueArrayC = []
    const uniqueNames = []
    const uniqueCategories = []


    response.data.map(item => {
        var findItem = uniqueArrayN.find(x => x.Name === item.Name);
        if (!findItem) {
            uniqueArrayN.push(item);
            uniqueNames.push(item.Name);
        }

        var findItem2 = uniqueArrayC.find(y => y.Category === item.Category);
        if (!findItem2) {
            uniqueArrayC.push(item);
            uniqueCategories.push(item.Category);
        }
    });

    // recorro el array con las distintas series y luego recorro los datos del API para crear el array datosSeries
    uniqueNames.map((f, j) => {
        var datosSerie = []
        var color = ''
        var nombre = ''
        for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            if (element.Name == uniqueNames[j]) {
                datosSerie.push([parseFloat(element.Valor)])
                color = element.Color
                nombre = element.Name
            }
        }

        chartBar.push(
            {
                datos: datosSerie,
                color: color,
                name: nombre
            }
        )
    }
    )



    return { chartBar: chartBar, categories: uniqueCategories }
}

export default BarStackedDataAPI